import axios from "infra/http";
import { useMutation } from "react-query";
import { showSuccess } from "infra/helpers/alerta";

function useReenviarEmails(refetch?: () => any) {
  return useMutation(
    (emailsIds: string[]) => {
      return axios.post(`/v1/relatorios/emails/reenviar`, { emailsIds });
    },
    {
      onSuccess(_, emailsIds) {
        showSuccess(emailsIds.length > 1 ? "Os emails serão reenviados em breve" : 'O email será reenviado em breve');

        refetch?.();
      },
    }
  );
}

export default useReenviarEmails;
